import styled from "styled-components";

const WtpBlue = styled.span`
  color: #414142;
  font-weight: bold;
`;
const Highlights = styled.span`
  font-weight: bold;
`;

const Deadline = styled.span`
  color: #dc3545;
`;

const Red = styled.span`
  color: red;
`;

const Title = styled.h2`
  font-size: 1.2rem;
  font-weight: 700;
  margin-top: 1rem;
  margin-bottom: 0.3rem;
  color: #414142;
`;
const Bold = styled.span`
  font-size: 1.2rem;
  font-weight: 700;
  color: #414142;
`;

const List = styled.div`
  margin-top: 2rem;
`;

const Item = styled.div`
  background-color: #f8f9fa;
  --border-radius: 8px;
  --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  margin-bottom: 1rem;

  list-style: none;
  padding-left: 1rem;
`;

const Description = styled.li`
  font-size: 1.1rem;
  color: #444444;
  line-height: 1.8;
  &:before {
    content: "•";
    color: #22365c;
    margin-right: 0.5rem;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin: 24px 0;
`;

const Diamond = styled.span`
  font-size: 1.3rem;
  margin-right: 8px;
  line-height: 1;
`;

const DTitle = styled.span`
  font-size: 1.3rem;
  font-weight: 600;
  white-space: nowrap;
`;

const DLine = styled.div`
  flex: 1;
  height: 1px;
  background-color: #cfcfcf;
  margin-left: 12px;
`;

export {
  Highlights,
  WtpBlue,
  Deadline,
  Red,
  Title,
  List,
  Item,
  Description,
  Bold,
  SectionHeader,
  Diamond,
  DTitle,
  DLine,
};
